<main #mainElement class="w-full show">
	<lbca-input-text-condensed
		[disabled]="isDisabled"
		[tabeled]="isTabeled"
		[labeled]="!isLabeled"
		[editable]="isEditable"
		[require]="isRequired"
		[helperText]="helperTextValue"
		[label]="labelValue"
		(change)="changeEvent($event)"
		(click)="click()"
		(focusState)="setFocus($event)"
		[componetIconStyle]="componetIconStyle"
		[componetHelperIconStyle]="componetHelperIconStyle"
		[hasExternalError]="hasError"
		[value]="valueInput"
	></lbca-input-text-condensed>
</main>
<ng-template cdkPortal #templateAppend="cdkPortal">
	@if (!isLabeled || isTabeled || (isEditable && isLabeled)) {
		<div
			class="select-template-condensed"
			[ngClass]="{
				'bg-gray-100 cursor-not-allowed': isDisabled,
				'mt-[18px]': helperTextValue && helperTextValue !== '',
				'mt-[12px]': helperTextValue && helperTextValue === ''
			}"
			[ngStyle]="{ width: bindProperties.width + 'px', height: bindProperties.height + 16 + 'px' }"
		>
			@if (optionFiltered.length > 0) {
				<div class="overflow-y-scroll" [ngStyle]="{ height: bindProperties.height + 'px' }">
					@for (option of optionFiltered; track option) {
						<div class="st-margin">
							<div (mousedown)="selectOption($event, option)" class="st-option">
								{{ option.label }}
							</div>
						</div>
					}
				</div>
			}
			@if (optionFiltered.length === 0) {
				<span class="st-notfound">Não encontramos nenhum resultado.</span>
			}
		</div>
	}
</ng-template>
